import React, { useEffect, useState } from 'react';
import { AppRouter } from 'app/providers/Router';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'shared/ui/Loader/Loader';
import { useApi } from 'app/api/APIProvider';
import { APIError, Nullable } from 'app/api/NewAPI';
import { useDispatch, useSelector } from 'react-redux';
import { getRestartState } from '../features/User/modal/selectors/getUserData/getUserData';
import { servicesActions } from 'features/Services';
import { getUserData, userActions } from 'features/User';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { APIUser } from './api/APITypes';
import 'app/styles/index.scss';

const App = () => {
    const token = sessionStorage.getItem('accessToken');
    const api = useApi();
    const user = api.User;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ready, setReady] = useState<typeof api.LoginState>(null);
    // @ts-ignore
    // const user = useSelector(getUserData);
    // const [user, setUser] = useState<Nullable<APIUser>>(null);

    const setCommonData = async () => {
        // const shopProducts = await api.GetProducts({});
        const specialProducts = await api.GetSpecialProducts();
        const productsInfo = await api.GetFinanceInfo();
        const cart = await api.GetCart();
        // const user = await api.GetUser();

        // dispatch(servicesActions.setProducts(shopProducts));
        dispatch(servicesActions.setSpecialProducts(specialProducts));
        dispatch(servicesActions.setProductsInfo(productsInfo));
        dispatch(userActions.setCart(cart));
        // dispatch(userActions.setUser(user));
    };

    useEffect(() => {
        api.Init().then((r) => {
            setReady(r);
            api.SetLoginState(r);
        });
    }, []);

    useEffect(() => {
        if (user) {
            setCommonData();
        }
    }, [user]);

    useEffect(() => {
        // Времменая мера
        if (sessionStorage.getItem('isDropped') === 'true') {
            navigate('avatar');
            return;
        }
        api.GetUser().then((user) => {
            // setUser(user)
            if (api.LoginState === 'logged_in') {
                api.GameData().then((res) => {
                    dispatch(userActions.setGameData(res));
                });
            }
        })
            .catch((error: APIError) => {
                api.SetLoginState('not_logged_in');
                navigate('start');
            });
    }, []);

    useEffect(() => {
        if (!user) return;
        if (api.LoginState === 'not_logged_in' || api.LoginState === null) {
            // navigate('auth');
            navigate('start');
        }
        // if (!user.current_scene) {
        //     // Пользователь не проходил ни одну сцену
        // } else {
        //
        // }
    }, [user]);

    // useEffect(() => {
    //     console.log(user, 'ready')
    // }, [user])

    return (
        <div>
            {ready === null ? <PageLoader /> : <AppRouter />}
            {/* <AppRouter /> */}
        </div>
    );
};

export default App;
